import { render, staticRenderFns } from "./DatePickerCom.vue?vue&type=template&id=53c9b5b2&scoped=true"
import script from "./DatePickerCom.vue?vue&type=script&lang=js"
export * from "./DatePickerCom.vue?vue&type=script&lang=js"
import style0 from "./DatePickerCom.vue?vue&type=style&index=0&id=53c9b5b2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53c9b5b2",
  null
  
)

export default component.exports